// extracted by mini-css-extract-plugin
export var container = "_dq-0";
export var icon = "_dq-1";
export var text = "_dq-2";